import React, { memo, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Form, message, Button, Upload } from 'antd';

// components
import PreviewMedia from 'components/Forms/Fields/PreviewMedia';

// Helper
import { normFile } from 'utils/uploadHelper';

// global user
import { useGetLocalUser } from 'engine/Contexts/User.context';

function MediaFormPreview({
  formData,
  isEdit,
  currentStep,
  // actions
  nextStep,
  prevStep,
  goToStep,
  result,
  // default
  className,
}) {
  const childClassName = classNames('form-absence', className);

  const localUser = useGetLocalUser()();

  const [isDisabled, setIsDisabled] = useState(false);
  const [AbsFormMediaPreview] = Form.useForm();

  const [mediaFiles, setMediaFiles] = useState([]);

  /*
   * Check current form data from parent
   * Set old data to the form
   */
  useEffect(() => {
    if (
      formData &&
      formData.hasOwnProperty('media') &&
      formData?.media.length > 0
    ) {
      AbsFormMediaPreview.setFieldsValue(formData);
      setMediaFiles(formData.media);
      setIsDisabled(false);
    } else {
      // go to preview file
      goToStep !== undefined && goToStep(currentStep - 1);
    }
  }, [formData]);

  const onFinish = values => {
    if (values && values.hasOwnProperty('media')) {
      if (values.media) {
        result(values);
      } else {
        delete formData.media;
        setMediaFiles([]);
        result(formData);
      }
    }
    nextStep !== undefined && nextStep();
    AbsFormMediaPreview.resetFields();
  };

  const fileOnRemove = useCallback(
    file => {
      if (formData && formData.hasOwnProperty('media')) {
        const { media, ...objInfo } = formData;
        setMediaFiles([]);
        result({
          ...objInfo,
          media: []
        });
      }
      goToStep !== undefined && prevStep();
      AbsFormMediaPreview.resetFields();
    },
    [formData, formData?.media],
  );

  const customItemRender = (originNode, file) => {
    return <PreviewMedia file={file} remove={fileOnRemove} />;
  };

  const goBack = () => {
    let toStep = currentStep - 2;
    //prevStep !== undefined && prevStep();
    goToStep !== undefined && goToStep(toStep);
    AbsFormMediaPreview.resetFields();
  };

  return (
    <div className={childClassName}>
      <Form
        form={AbsFormMediaPreview}
        className="form-absence__form form-proof__form"
        name="form_absence_media_upload"
        initialValues=""
        onFinish={onFinish}
        onValuesChange={() => setIsDisabled(false)}
      >
        <div className="form-proof">
          <Form.Item
            name="media"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            noStyle
            normalize={(value, prevValue, prevValues) => {
              if (value.length > 1) {
                message.error('You can only upload 1 file!');
                return false;
              }
            }}
          >
            <Upload
              multiple={false}
              maxCount={1}
              fileList={mediaFiles}
              onRemove={fileOnRemove}
              itemRender={customItemRender}
            />
          </Form.Item>
        </div>

        <div className="absence-actions-wrapper">
          {((!isEdit && localUser?.role == 'parent') ||
            ((isEdit || !isEdit) && localUser?.role == 'teacher')) && (
            <Button className="btn-previous" onClick={goBack}>
              Précédent
            </Button>
          )}

          <Button
            className="next-btn"
            form={`form_absence_media_upload`}
            htmlType="submit"
            disabled={isDisabled}
          >
            Suivant
          </Button>
        </div>
      </Form>
    </div>
  );
}

MediaFormPreview.defaultProps = {};
MediaFormPreview.propTypes = {
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
};

export default memo(MediaFormPreview);
